import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OnbudsmanComponent } from './onbudsman.component';
import { OnbudsmanRoutingModule } from './onbudsman-routing.module';

// import { CustomFormsModule } from 'ngx-custom-validators';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Atuar na conversão do header para que as Apis do TI, consigam
// receber as aquisições corretamente com Json via "RESPONSE HEADERS" e "REQUEST HEADERS"
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';

@NgModule({
    declarations: [OnbudsmanComponent],
    imports: [
        CommonModule,
        RouterModule,
        OnbudsmanRoutingModule,
        NgbModule,
        HttpClientModule,

        FormsModule,
        ReactiveFormsModule,
        Interceptor,
    ],
})
export class OnbudsmanModule {}
